import {useState, useContext,useEffect} from 'react'
import UserContext from '../UserContext'
import Logoname from "../img/logo/logo-name.png";

function LoginFooter(){
  const { mode } = useContext(UserContext)
  // setting the theme
  const [dark,setDark] = useState(false)
  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")?JSON.parse(localStorage.getItem("darkmode")):false
    setDark(darkmode)
  },[mode])
   return(
       <div className="">
         <footer className={dark?" p-5 text-center darkmode":" p-5 text-center "}>
             <div className="flex w-full gap-3 items-center justify-center"><span className="power">Powered By</span> <img src={Logoname} alt="Logo" width="50"/></div>
         </footer>
       </div>
   )
}

export default LoginFooter;